import React from 'react';
import IntroSection from './IntroSection';
import { PageLayout } from '@/components';

const Home: React.FC = () => {
  return (
    <PageLayout>
      <IntroSection />
    </PageLayout>
  );
}

export default Home;
